import React from 'react';

const UserSvg = ({ color = '#006CDD', size = 20, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
        <path
            d="M10 3.33333C10.8841 3.33333 11.7319 3.68452 12.357 4.30964C12.9821 4.93476 13.3333 5.78261 13.3333 6.66667C13.3333 7.55072 12.9821 8.39857 12.357 9.02369C11.7319 9.64881 10.8841 10 10 10C9.11594 10 8.2681 9.64881 7.64298 9.02369C7.01786 8.39857 6.66667 7.55072 6.66667 6.66667C6.66667 5.78261 7.01786 4.93476 7.64298 4.30964C8.2681 3.68452 9.11594 3.33333 10 3.33333ZM10 11.6667C13.6833 11.6667 16.6667 13.1583 16.6667 15V16.6667H3.33333V15C3.33333 13.1583 6.31667 11.6667 10 11.6667Z"
            fill={color}
        />
    </svg>
);

export default UserSvg;
